export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/index.vue'),
    /* no children */
  },
  {
    path: '/academy',
    /* internal name: '/academy' */
    /* no component */
    children: [
      {
        path: '',
        name: '/academy/',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/academy/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        /* internal name: '/academy/[id]' */
        /* no component */
        children: [
          {
            path: '',
            name: '/academy/[id]/',
            component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/academy/[id]/index.vue'),
            /* no children */
          },
          {
            path: ':season',
            /* internal name: '/academy/[id]/[season]' */
            /* no component */
            children: [
              {
                path: 'info',
                name: '/academy/[id]/[season]/info',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/academy/[id]/[season]/info.vue'),
                /* no children */
              },
              {
                path: 'schedule',
                name: '/academy/[id]/[season]/schedule',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/academy/[id]/[season]/schedule.vue'),
                /* no children */
              },
              {
                path: 'scores',
                name: '/academy/[id]/[season]/scores',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/academy/[id]/[season]/scores.vue'),
                /* no children */
              },
              {
                path: 'seasons',
                name: '/academy/[id]/[season]/seasons',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/academy/[id]/[season]/seasons.vue'),
                /* no children */
              },
              {
                path: 'standings',
                name: '/academy/[id]/[season]/standings',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/academy/[id]/[season]/standings.vue'),
                /* no children */
              },
              {
                path: 'statistics',
                name: '/academy/[id]/[season]/statistics',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/academy/[id]/[season]/statistics.vue'),
                /* no children */
              },
              {
                path: 'statistics__',
                name: '/academy/[id]/[season]/statistics__',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/academy/[id]/[season]/statistics__.vue'),
                /* no children */
              },
              {
                path: 'stats',
                /* internal name: '/academy/[id]/[season]/stats' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/academy/[id]/[season]/stats/',
                    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/academy/[id]/[season]/stats/index.vue'),
                    /* no children */
                  },
                  {
                    path: 'goalies',
                    name: '/academy/[id]/[season]/stats/goalies',
                    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/academy/[id]/[season]/stats/goalies.vue'),
                    /* no children */
                  },
                  {
                    path: 'skaters',
                    name: '/academy/[id]/[season]/stats/skaters',
                    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/academy/[id]/[season]/stats/skaters.vue'),
                    /* no children */
                  },
                  {
                    path: 'teams',
                    name: '/academy/[id]/[season]/stats/teams',
                    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/academy/[id]/[season]/stats/teams.vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'stats copy',
                name: '/academy/[id]/[season]/stats copy',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/academy/[id]/[season]/stats copy.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'schedule',
            name: '/academy/[id]/schedule',
            component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/academy/[id]/schedule.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/articles',
    /* internal name: '/articles' */
    /* no component */
    children: [
      {
        path: '',
        name: '/articles/',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/articles/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/articles/[id]',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/articles/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/contact',
    name: '/contact',
    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/contact.vue'),
    /* no children */
  },
  {
    path: '/eventdatalog',
    /* internal name: '/eventdatalog' */
    /* no component */
    children: [
      {
        path: ':id',
        name: '/eventdatalog/[id]',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/eventdatalog/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/events',
    /* internal name: '/events' */
    /* no component */
    children: [
      {
        path: ':id',
        name: '/events/[id]',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/events/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/gdpr',
    name: '/gdpr',
    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/gdpr.vue'),
    /* no children */
  },
  {
    path: '/hobby',
    /* internal name: '/hobby' */
    /* no component */
    children: [
      {
        path: '',
        name: '/hobby/',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/hobby/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        /* internal name: '/hobby/[id]' */
        /* no component */
        children: [
          {
            path: '',
            name: '/hobby/[id]/',
            component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/hobby/[id]/index.vue'),
            /* no children */
          },
          {
            path: ':season',
            /* internal name: '/hobby/[id]/[season]' */
            /* no component */
            children: [
              {
                path: 'info',
                name: '/hobby/[id]/[season]/info',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/hobby/[id]/[season]/info.vue'),
                /* no children */
              },
              {
                path: 'schedule',
                name: '/hobby/[id]/[season]/schedule',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/hobby/[id]/[season]/schedule.vue'),
                /* no children */
              },
              {
                path: 'scores',
                name: '/hobby/[id]/[season]/scores',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/hobby/[id]/[season]/scores.vue'),
                /* no children */
              },
              {
                path: 'seasons',
                name: '/hobby/[id]/[season]/seasons',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/hobby/[id]/[season]/seasons.vue'),
                /* no children */
              },
              {
                path: 'standings',
                name: '/hobby/[id]/[season]/standings',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/hobby/[id]/[season]/standings.vue'),
                /* no children */
              },
              {
                path: 'statistics',
                name: '/hobby/[id]/[season]/statistics',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/hobby/[id]/[season]/statistics.vue'),
                /* no children */
              },
              {
                path: 'statistics__',
                name: '/hobby/[id]/[season]/statistics__',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/hobby/[id]/[season]/statistics__.vue'),
                /* no children */
              },
              {
                path: 'stats',
                /* internal name: '/hobby/[id]/[season]/stats' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/hobby/[id]/[season]/stats/',
                    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/hobby/[id]/[season]/stats/index.vue'),
                    /* no children */
                  },
                  {
                    path: 'goalies',
                    name: '/hobby/[id]/[season]/stats/goalies',
                    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/hobby/[id]/[season]/stats/goalies.vue'),
                    /* no children */
                  },
                  {
                    path: 'skaters',
                    name: '/hobby/[id]/[season]/stats/skaters',
                    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/hobby/[id]/[season]/stats/skaters.vue'),
                    /* no children */
                  },
                  {
                    path: 'teams',
                    name: '/hobby/[id]/[season]/stats/teams',
                    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/hobby/[id]/[season]/stats/teams.vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'stats copy',
                name: '/hobby/[id]/[season]/stats copy',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/hobby/[id]/[season]/stats copy.vue'),
                /* no children */
              }
            ],
          }
        ],
      }
    ],
  },
  {
    path: '/hrat-superligu',
    name: '/hrat-superligu',
    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/hrat-superligu.vue'),
    /* no children */
  },
  {
    path: '/leagues',
    /* internal name: '/leagues' */
    /* no component */
    children: [
      {
        path: '',
        name: '/leagues/',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        /* internal name: '/leagues/[id]' */
        /* no component */
        children: [
          {
            path: '',
            name: '/leagues/[id]/',
            component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/index.vue'),
            /* no children */
          },
          {
            path: ':season',
            /* internal name: '/leagues/[id]/[season]' */
            /* no component */
            children: [
              {
                path: 'info',
                name: '/leagues/[id]/[season]/info',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/[season]/info.vue'),
                /* no children */
              },
              {
                path: 'schedule',
                name: '/leagues/[id]/[season]/schedule',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/[season]/schedule.vue'),
                /* no children */
              },
              {
                path: 'scores',
                name: '/leagues/[id]/[season]/scores',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/[season]/scores.vue'),
                /* no children */
              },
              {
                path: 'seasons',
                name: '/leagues/[id]/[season]/seasons',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/[season]/seasons.vue'),
                /* no children */
              },
              {
                path: 'standings',
                name: '/leagues/[id]/[season]/standings',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/[season]/standings.vue'),
                /* no children */
              },
              {
                path: 'statistics',
                name: '/leagues/[id]/[season]/statistics',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/[season]/statistics.vue'),
                /* no children */
              },
              {
                path: 'statistics__',
                name: '/leagues/[id]/[season]/statistics__',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/[season]/statistics__.vue'),
                /* no children */
              },
              {
                path: 'stats',
                /* internal name: '/leagues/[id]/[season]/stats' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/leagues/[id]/[season]/stats/',
                    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/[season]/stats/index.vue'),
                    /* no children */
                  },
                  {
                    path: 'goalies',
                    name: '/leagues/[id]/[season]/stats/goalies',
                    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/[season]/stats/goalies.vue'),
                    /* no children */
                  },
                  {
                    path: 'skaters',
                    name: '/leagues/[id]/[season]/stats/skaters',
                    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/[season]/stats/skaters.vue'),
                    /* no children */
                  },
                  {
                    path: 'teams',
                    name: '/leagues/[id]/[season]/stats/teams',
                    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/[season]/stats/teams.vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'stats copy',
                name: '/leagues/[id]/[season]/stats copy',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/[season]/stats copy.vue'),
                /* no children */
              }
            ],
          }
        ],
      }
    ],
  },
  {
    path: '/match',
    /* internal name: '/match' */
    /* no component */
    children: [
      {
        path: ':id',
        name: '/match/[id]',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/match/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/newarticle',
    /* internal name: '/newarticle' */
    /* no component */
    children: [
      {
        path: '',
        name: '/newarticle/',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/newarticle/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/newarticle/[id]',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/newarticle/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/newleague',
    /* internal name: '/newleague' */
    /* no component */
    children: [
      {
        path: '_index',
        name: '/newleague/_index',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/newleague/_index.vue'),
        /* no children */
      },
      {
        path: ':id?',
        name: '/newleague/[[id]]',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/newleague/[[id]].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/newteam',
    /* internal name: '/newteam' */
    /* no component */
    children: [
      {
        path: '_index',
        name: '/newteam/_index',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/newteam/_index.vue'),
        /* no children */
      },
      {
        path: ':id?',
        name: '/newteam/[[id]]',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/newteam/[[id]].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/organisations',
    name: '/organisations',
    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/organisations.vue'),
    /* no children */
  },
  {
    path: '/out',
    /* internal name: '/out' */
    /* no component */
    children: [
      {
        path: '_statsaadadad',
        /* internal name: '/out/_statsaadadad' */
        /* no component */
        children: [
          {
            path: '',
            name: '/out/_statsaadadad/',
            component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/out/_statsaadadad/index.vue'),
            /* no children */
          },
          {
            path: 'goalies',
            name: '/out/_statsaadadad/goalies',
            component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/out/_statsaadadad/goalies.vue'),
            /* no children */
          },
          {
            path: 'layout',
            name: '/out/_statsaadadad/layout',
            component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/out/_statsaadadad/layout.vue'),
            /* no children */
          },
          {
            path: 'skaters',
            name: '/out/_statsaadadad/skaters',
            component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/out/_statsaadadad/skaters.vue'),
            /* no children */
          },
          {
            path: 'teams',
            name: '/out/_statsaadadad/teams',
            component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/out/_statsaadadad/teams.vue'),
            /* no children */
          }
        ],
      },
      {
        path: ':season copy',
        name: '/out/[season] copy',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/out/[season] copy.vue'),
        /* no children */
      },
      {
        path: 'stats 0',
        name: '/out/stats 0',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/out/stats 0.vue'),
        /* no children */
      },
      {
        path: 'stats 2',
        name: '/out/stats 2',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/out/stats 2.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/password',
    name: '/password',
    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/password.vue'),
    /* no children */
  },
  {
    path: '/register',
    name: '/register',
    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/register.vue'),
    /* no children */
  },
  {
    path: '/register-dependent',
    name: '/register-dependent',
    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/register-dependent.vue'),
    /* no children */
  },
  {
    path: '/teams',
    /* internal name: '/teams' */
    /* no component */
    children: [
      {
        path: '',
        name: '/teams/',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/teams/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/teams/[id]',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/teams/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/users',
    /* internal name: '/users' */
    /* no component */
    children: [
      {
        path: 'userList',
        name: '/users/userList',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/users/userList.vue'),
        /* no children */
      },
      {
        path: 'userProfile',
        name: '/users/userProfile',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/users/userProfile.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/verify-email',
    name: '/verify-email',
    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/verify-email.vue'),
    /* no children */
  }
]

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

